var map = {
	"./action_shap.png": 141,
	"./author_img.png": 142,
	"./banner_bg.png": 88,
	"./banner_img.png": 89,
	"./divider.png": 92,
	"./dot.png": 93,
	"./icon01.png": 143,
	"./icon02.png": 144,
	"./icon3.png": 145,
	"./icon_04.png": 146,
	"./icon_05.png": 147,
	"./icon_shape1.png": 148,
	"./icon_shape2.png": 149,
	"./icon_shape3.png": 150,
	"./icon_shape4.png": 151,
	"./process_1.png": 152,
	"./process_2.png": 153,
	"./process_3.png": 154,
	"./process_4.png": 155,
	"./process_5.png": 156,
	"./shape.png": 157,
	"./team1.jpg": 61,
	"./team2.jpg": 35,
	"./work1.png": 158,
	"./work2.png": 159,
	"./work3.png": 160
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 60;